<script setup lang="ts">
import { Symbols } from "@/shared/data-display-config/composable/data-display.helper";

defineProps<{
    symbols: NonNullable<Symbols>;
}>();
</script>

<template>
    <i v-for="symbol in symbols" :key="symbol.icon" :class="`q-mr-sm fa-regular ${symbol.icon}`">
        <q-tooltip v-if="symbol.label">{{ symbol.label }}</q-tooltip>
    </i>
</template>
